module.exports = __webpack_public_path__ + "static/media/Picture4.1cc303e8.jpg";